import React from 'react'
import { useTranslation } from 'next-i18next'
import { Typography } from 'antd'
import SmallRegisterFootPrintForm from './SmallRegisterFootPrintForm/SmallRegisterFootPrintForm'
import RegisterFootPrintButtonsContent from './RegisterFootPrintButtonsContent/RegisterFootPrintButtonsContent'
const { Text } = Typography

function RegisterFootPrint({ footPrintTypes }) {
  const { t } = useTranslation()

  return (
    <div>
      <Text>{t('footPrint.ResgisterLabel')}</Text>
      {/* Small FootPrint Form */}
      <SmallRegisterFootPrintForm footPrintTypes={footPrintTypes} />
      {/* Buttons Content */}
      <RegisterFootPrintButtonsContent />
    </div>
  )
}

export default RegisterFootPrint
